module.exports = {
  COUNTRYCODE_TYPEAHEAD: 'access/v1/countrycode/',
  USER_INFO: 'access/v1/getuserinfo/',
  COUNTRY_CODES: 'access/v1/countrycode',
  INVITE_STATUS: 'access/v1/invitestatus/',
  SIGNUP: 'access/v2/register/',
  SEND_OTP: 'access/v1/sendotp/',
  GENERATE_OTP: 'access/v1/generateotp/',
  SET_PASSWORD: 'access/v1/setpassword/',
  FETCH_AUTH: 'access/v1/fetchauthmode/',
  LOGIN: 'access/v1/login/',
  LOGOUT: 'access/v1/logout/',
  INVITE_USER: 'access/v3/empinvite/',
  GET_ADDRESS_LIST: 'organisation/v2/address/',
  SEARCH: 'search/v1/search/',
  GET_SEARCH_FIELDS: 'search/v1/searchfields/',
  SAVE_FILTER: '/search/v1/searchconfiguration/',
  CONTROLLED_USER_INFO: 'access/v2/controlleduserinfo/',
  PENDING_EMP_INVITE: 'access/v1/invitepending/',
  CARD_STATUS: 'card/v1/card-transition-status/',
  REPORT_CARD: 'card/v1/reportcard/',
  CARD_STATUS_SWITCH: 'card/v1/changecardstatus/',
  ASSIGN_CARD: 'card/v1/bulk/charge-card-assign/',
  ACTIVATE_CARD: 'card/v1/activatecard/',
  CARD_AUTH: 'card/v1/viewcardpwd/',
  VIEW_CARD: 'card/v1/viewcard/',
  SEARCH_FIELDS: 'search/v1/searchfields/',
  SAVE_FILTERS: 'search/v1/searchconfiguration/',
  PARTICULAR_CARD_DATA: 'card/v1/carddetails/',
  GET_SINGLE_TRANSACTION: 'transaction/v1/transaction/id/',
  BILL_ATTACHMENT: 'transaction/v1/attachments/',
  TRAVEL_CONFIG: 'card/v1/foreign-travel-config/',
  COUNTRY_LIST: 'organisation/v1/happaycountrytypeahead/',
  WALLET_LIMITS: 'wallet/v1/walletlimits/',
  EXPENSE_ATTACHMENT_DELETE: 'transaction/v1/deleteattachments/',
  DISPUTE_EXPENSE: 'transaction/v1/dispute_transaction/',
  DISPUTE_REASONS: 'transaction/v1/dispute-reasons/',
  DISPUTE_WITHDRAW: 'transaction/v1/dispute-withdraw/',
  GET_MERCHANT: 'card/v1/gmr/merchant_details/',
  UPDATE_CARD_MERCHANT: 'card/v1/edit/merchant-details/',
  SEARCH_ADDRESSS: 'organisation/v1/search-place/',
  GET_PLACE: 'organisation/v1/get-place/',
  RESEND_INVITE: 'access/v3/empinvite/resend/',
  CONNECT_PLAID: 'bankadaptor/v1/connect_plaid_account/',
  UPDATE_BANK_ACCOUNT: 'bankadaptor/v1/updatebankaccount/',
  INVOICE_PRODUCT_LIST: 'entity/v1/org-products/',
  FULL_KYC: 'access/v1/uploadkyc/',
  MIN_KYC: 'access/v1/min_kyc/',
  SET_CARD_PIN_INIT: 'card/v1/pin/init/',
  CARD_PIN_OTP_VERIFICATION: 'card/v1/pin/otp/',
  POST_NEW_PIN: 'card/v1/pin/set/',
  BILL_BALANCE: 'bankadaptor/v1/balances/bills/',
  UPDATE_USER_LIMIT: 'wallet/v1/walletlimitconfigedit/',
  BILL_DETAILS: 'bankadaptor/v1/balances/bill/',
  BILL_TRANSACTIONS: 'bankadaptor/v1/balances/bill/transactions/',
  BILL_PENALTIES: 'bankadaptor/v1/balances/bill/penalties/',
  GET_CURRENCT_BALANCE: 'bankadaptor/v1/balances/current/bill/',
  CARD_BLOCK_CONFIG: 'card/v1/limit-block-config/',
  VIRTUAL_ACC_DETAILS: 'virtualaccount/v1/virtualaccount/',
  DOWNLOAD_ETL: 'etl/v1/download/',
  BILL_PDF_XLS_CSV: 'bankadaptor/v1/balances/bill/export',
  ANALYTICS: 'analytics/v1/epicanalytics/',
  KYCADDRESS: 'access/v2/useraddress/',
  VIDEOKYC: 'access/v1/video-kyc/',
  EDITUSERMOBILENO: 'access/v2/edituser/',
  EDITNAME: 'access/v1/edituserinfo/',
  DOCTYPE: 'access/v1/kyc-doc-type/',
  TRANSACTION_UPDATE: 'transaction/v1/transaction/id/',
  CONTROLLED_USER: 'access/v2/controlledusers/',
  REQUEST_CARD: 'card/v1/card-request-flow-epic/',
  USER_ONBOARD_FLOW: 'access/v1/onboarding-guide/',
  MANDATE_EXIST: 'transaction/v1/mandate-exist/',
  MANDATE_DETAILS: 'transaction/v1/mandate-details/',
  GENERATE_MANDATE_OTP: 'transaction/v1/generate-otp/',
  CREATE_MANDATE: 'transaction/v1/create-mandate/',
  UPDATE_MANDATE: 'transaction/v1/update-mandate/',
  DELETE_MANDATE: 'transaction/v1/delete-mandate/',
  EMANDATE_AUDIT_TRAILS: 'transaction/v1/audit-trail',
  SSO_CHECK: 'access/v2/sso/',
  SSO_CONFIGURATION: 'access/v2/ssoconfig/',
  SSO_PROVIDER: 'access/v2/sso_providers/',
  MY_INVOICE_SEARCH: 'ipp/v1/my_invoice_search/',
  MY_INVOICE_APPROVALS: 'ipp/v1/my_invoice_approvals/',
  MY_VENDOR_SEARCH: 'ipp/v1/my_vendor_search/',
  MY_VENDOR_APPROVALS: 'ipp/v1/my_vendor_approvals/',
  CREATE_VENDOR: 'ipp/v1/vendor/',
  SAVE_INVOICE: 'ipp/v1/invoice/',
  SUBMIT_INVOICE: 'ipp/v1/invoice-submit/',
  SUBMIT_VENDOR: 'ipp/v1/vendor-submit/',
  VENDOR_LIST: 'ipp/v1/vendor_list/',
  ORG_CURRENCY: 'organisation/v1/configorgcurrency/',
  GET_GSTIN_DATA: 'ipp/v1/gstin_data/',
  CITY_TYPEAHEAD: 'organisation/v1/happaycitytypeahead/',
  GLOBAL_SEARCH_INVOICE: 'ipp/v1/invoice_global_search/',
  GLOBAL_SERACH_VENDOR: 'ipp/v1/vendor_global_search/',
  INVOICE_EXPORT: 'ipp/v1/invoice-export/',
  VENDOR_EXPORT: 'ipp/v1/vendor-export/',
  RESOURCE_DETAILS: 'workflow/v1/resource-details/',
  TRACK_WORKFLOW: 'workflow/v1/track-workflows/',
  STATE_SETTING: 'workflow/v1/state-settings/',
  WORKFLOW_ACTION: 'workflow/v1/container-action/',
  INVOICE_UPDATE: 'ipp/v1/invoice_update/',
  VENDOR_UPDATE: 'ipp/v1/vendor_update/',
  WORKFLOW_COMMENTS: 'workflow/v1/comment/',
  TABLE_COLUMN: 'search/v1/columns/',
  IFSC_BANK_DETAILS: 'payment/v1/ifsccode/',
  DOWNLOAD_BULK_TEMPLATE: 'ipp/v1/vendor-bulk-create/',
  CHEQUE_INFO: 'ocr/v1/make-ocr-cheque-req/',
  S3_ATTACHMENT: 'transaction/v1/attachments-s3/',
  ORC_PARSER: 'ocr/v1/make-ocr-generic-req/generic/',
  SESSION_LOGIN_OTP: 'access/v1/session-login-send-otp/',
  SESSION_VERIFY_OTP: 'access/v1/session-login-verify-otp/',
  CANCEL_PAYMENT: 'ipp/v1/invoice_cancelation/',
  RESCHEDULE_PAYMENT: 'ipp/v1/invoice_reschedule/',
  TUTORIAL_FLAG: 'ipp/v1/tutorial-flags/',
  INVOICE_BULK: 'workflow/v1/bulkaction/'
};
